import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { Section } from 'components/Section';
import { Tooltip } from 'components/Tooltip';

import './styles.scss';

export function MetricsGrid(props: {
  description?: string,
  title: string,
  items: {label: string, value: string, tooltip?: string, highlight?: boolean}[]
}) {
  return (
    <Section title={props.title}>
      {props.description &&
        <Box p={2} mb={3} style={{ border: '2px solid #385F99' }} className="lens-rounded-md">
          {props.description}
        </Box>
      }
      <div className='d-flex flex-row flex-wrap' style={{margin: '-8px'}}>
        {props.items
          .map((item, i) => {
            return (
              <div
                className='d-flex flex-column p-2 m-2 box lens-rounded-md'
                key={i}
                style={{border: item.highlight ? '2px solid #385F99' : '1px solid #dee2e6'}}
              >
                <div className='d-flex flex-row'>
                  <Typography className='metricLabel text-uppercase'>{item.label}</Typography>
                  {item.tooltip && <Tooltip title={item.tooltip}/>}
                </div>
                <Typography className='metricValue lens-h4'>{item.value}</Typography>
              </div>
            );
          })}
      </div>
    </Section>
  );
}
